<template>
  <div class="container">
    <Title></Title>
    <div class="box">
      <!-- 顶部大图--头 -->
      <!-- <div class="banner">
        <img src="../assets/img/introduction/banner.svg" alt="" />
        <h5>醴陵金融纠纷调解中心</h5>
      </div> -->
      <!-- 导航栏--头
      <div class="nav">
        <a href="" class="nav-01">
          <span></span>
          <p>调解中心简介</p>
        </a>
        <a href="">调解指南</a>
        <a href="">调解员名录</a>
        <a href="">判决案例</a>
        <a href="">法政法规</a>
      </div> -->
      <!-- 内容部分--头 -->
      <!-- 广告位 -->
      <advertisement />
      <interiorH :name="0" />
      <div class="introduction">
        <h5>中心简介</h5>
        <!-- <p class="data">2022-8-2</p> -->
        <p class="content" v-html="introduction"></p>
      </div>
      <!-- 更多推荐--头 -->
      <div class="more">
        <p>更多推荐</p>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- 更多推荐内容--头 -->
      <div class="morecontent">
        <div>
          <!-- 内容--头 -->
          <div @click="path(item.id, item.category_id)" class="recommend_list" v-for="(item, index) in recommend_list">
            <div>
              <img :src="item.thumbImage.fullImageUrl" alt="" />
            </div>
            <div class="content">
              <h5>{{ item.title }}</h5>
              <p class="desc">
                {{ item.description }}
              </p>
              <span>{{ item.author }}</span>
            </div>
          </div>
          <!-- 内容--尾部 -->
        </div>
      </div>
      <!-- 版权信息 -->
      <copyright />
    </div>
  </div>
</template>

<script>
import Title from "../components/title.vue";
import copyright from "../components/copyright.vue";
import interiorH from "../components/interiorH.vue";
import axios from "axios";
export default {
  components: {
    Title,
    copyright,
    interiorH
  },
  data() {
    return {
      introduction: '',
      recommend_list: []
    };
  },
  mounted() {
    this.getinfo()
  },
  methods: {
    async getinfo() {
      let res = await axios.post("/api/index/introduction")
      this.introduction = res.data.data.introduction
      this.recommend_list = res.data.data.recommend_list
    },
    path(article_id, category_id) {
      this.$router.push({ path: "/fingerpostI", query: { article_id, category_id } })
    }
  }
};
</script>

<style scoped>
.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 3rem 1rem 0 1rem;
}

a {
  text-decoration: none;
}

.recommend_list {
  display: flex;
  margin-bottom: 10px;
}

.desc {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* autoprefixer: ignore next */
  -webkit-line-clamp: 2;
}

/* p {
  width: 100%;
  height: 13.5rem;
  border-radius: 0.5rem;
  margin-top: 2.375rem;
  position: relative;
} */
.banner {
  position: relative;
  width: 22rem;
  height: 8.5rem;
  margin: 1.875rem auto;
  text-align: center;
}

.banner img {
  width: 100%;
  height: 100%;
}

.banner h5 {
  width: 100%;
  position: absolute;
  font-size: 1rem;
  color: #fff;
  top: 50%;
  margin-top: -0.5rem;
}

.nav {
  margin-top: -0.625rem;
  display: flex;
  margin-bottom: 1.75rem;
  overflow: auto;
}

::-webkit-scrollbar {
  display: none;
}

.nav .nav-01 span {
  display: inline-block;
  width: 0.9375rem;
  height: 0.9375rem;
  background: url(../assets/img/base/tjzxjj.svg) no-repeat center center;
}

.nav .nav-01 p {
  display: inline-block;
  font-weight: 500;
  color: #2b4ca4;
}

.nav a {
  font-size: 0.875rem;
  color: #333;
  white-space: nowrap;
  margin-right: 0.875rem;
}

.introduction {
  display: flex;
  flex-direction: column;
  margin: 0 0.625rem;
}

.introduction h5 {
  font-size: 1.0625rem;
  font-weight: 700;
  color: #333;
  margin: 0 auto;
}

.introduction .data {
  margin-top: 0.375rem;
  font-size: 0.75rem;
  color: #7d8184;
  text-align: right;
}

.introduction .content {
  margin-top: 0.9375rem;
  font-size: 0.875rem;
  line-height: 20px;
}

.more {
  margin-top: 3.125rem;
}

.more p {
  display: inline-block;
  font-size: 0.9375rem;
  color: #393c3f;
  margin-right: 0.3125rem;
}

.more span {
  display: inline-block;
  width: 0.25rem;
  height: 0.8294rem;
  transform: skew(-30deg);
  -webkit-transform: skew(-30deg);
  -moz-transform: skew(-30deg);
  -o-transform: skew(-30deg);
  -ms-transform: skew(-30deg);
  background-color: #0982f9;
}

.morecontent {
  margin-top: 0.875rem;
  display: flex;
  flex-direction: row;
}

.morecontent a {
  display: flex;
  flex-direction: row;
}

.morecontent img {
  width: 6.6875rem;
  height: 5rem;
  margin-right: 0.5rem;
}

.morecontent .content h5 {
  font-size: 0.875rem;
  font-weight: 500;
  color: #2b4ca4;
}

.morecontent .content p {
  font-size: 0.8125rem;
  color: #333;
  margin-top: 0.375rem;
}

.morecontent .content span {
  font-size: 0.8125rem;
  color: #e04044;
}
</style>



// WEBPACK FOOTER //
// src/page/introduction.vue